import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { SideBarContext } from '../context/SideBarContext';
import { Widths } from '../utils/Enums/Common';

export const SideBar = ({ children }: { children: React.ReactNode }) => {
    const { sideBarVissible, setSideBarVissible } = useContext(SideBarContext);
    const screenWidth = window.innerWidth;
    return (
        <div className={`${screenWidth < Widths.smallScreen && sideBarVissible && 'sidebar-overlay'}`}>
            <div className={`position-fixed sidebar flex-column vh-100 background-dark`}>
                <div className='d-flex justify-content-end'>
                    <Button
                        onClick={() => setSideBarVissible(false)}
                        className='background-unset position-relative end-0 z-5 mt-1 mx-2 border-0'
                    >
                        <FontAwesomeIcon icon={faTimes} size='2x' color='black'></FontAwesomeIcon>
                    </Button>
                </div>
                {children}
            </div>
        </div>
    );
};
